<!-- HTML -->
<template>
  <pl-dialog @close="handleModalClose" :maxWidth="'500px'">
    <pl-button
      class="pl-icon"
      style="position: absolute; top: 0; right: 0"
      @click.native="handleModalClose"
    >
      <i class="fa fa-close fa-lg"></i>
    </pl-button>
    <div class="p-5 h-full flex flex-col items-center justify-center">
      <div>
        <img class="upgrade-image" src="/static/stick_men/disco.svg" alt="" />
        <br /><br />
        <span class="pl-subheading"
          >Welcome to the
          <span class="primary"><strong>Parlay</strong></span> Family!</span
        >
      </div>
      <!-- Greeting message for one Teacher -->
      <div class="center-xs pl-subheading">
        <!-- Text if teacher activated parlay with a school code -->
        <template v-if="school_info">
          <span v-if="teacher_count <= 1">
            You are the
            <span class="secondary"><strong>first</strong></span>
            teacher using Parlay at
            <span class="primary"
              ><strong>{{ school_name }}</strong></span
            >!
          </span>
          <!-- Greeting message for Multiple Teachers -->
          <span v-else>
            There are now
            <span class="secondary"
              ><strong>{{ teacher_count }}</strong></span
            >
            teachers using Parlay at
            <span class="primary"
              ><strong>{{ school_name }}</strong></span
            >!
          </span>
        </template>

        <!-- Text if teacher activated parlay by paying independently -->
        <template v-else>
          <div class="flex flex-col justify-center">
            <p>You have unlimited classes on Parlay!</p>
            <pl-button
              class="pl-primary"
              @click.native="$router.push('dashboard')"
            >
              Go to my dashboard
            </pl-button>
            <!-- <pl-button class="pl-primary" @click.native="goToReferralPage">
            Tell my friends!
          </pl-button> -->
          </div>
        </template>
      </div>
    </div>
  </pl-dialog>
</template>

<!-- JS -->
<script lang="babel">

  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters([
      ]),
      school_info() {
        return localStorage.getItem('schoolInfoPostUpgrade')
          ? JSON.parse(localStorage.getItem('schoolInfoPostUpgrade'))
          : null;
      },
      school_name() {
        return this.school_info
          ? this.school_info.school_name
          : null;
      },
      teacher_count() {
        return this.school_info
          ? this.school_info.teacher_count
          : null;
      },
    },
    methods: {
      handleModalClose() {
        localStorage.removeItem('schoolInfoPostUpgrade');
        this.$emit('closeModal');
      },
      goToReferralPage() {
        this.$router.push({
          name: 'profile.index',
          query: {
            page: 'referrals',
          },
        });
        this.$emit('closeModal');
      },
    },
  };
</script>

<!-- CSS -->
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'

  .primary
    color: pl-primary

  .secondary
    color: pl-ruby

  .upgrade-image
    height: 235px
    width: 100%
</style>



// WEBPACK FOOTER //
// upgradeSuccessModal.vue?74f5f8fc